import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
export const globalfunc = {
  timeSince: (date) => {
    let secFormat = distanceInWordsStrict(new Date(), date, {unit: 's'})
    let seconds = parseInt(secFormat.replace(/ seconds/g, ""))
    var intervalType;

    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      intervalType = 'year';
    } else {
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        intervalType = 'month';
      } else {
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          intervalType = 'day';
        } else {
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            intervalType = "hour";
          } else {
            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
              intervalType = "min";
            } else {
              interval = seconds;
              intervalType = "second";
            }
          }
        }
      }
    }

    if (interval > 1 || interval === 0) {
      intervalType += 's';
    }

    return interval + ' ' + intervalType + ' ago';
  },
  getTeamOfParent: (parent, teams) => {
    for (const i in parent) {
      teams[parent[i]["team_id"]] = true;
      if (parent[i]["parent"]) {
        teams = globalfunc.getTeamOfParent(parent[i]["parent"], teams);
      }
    }
    return teams;
  },
  generateToken: (length) => {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    return result;
  }
}